export const environment = {
  production: false,
  staging: true,

  baseURL: 'https://staging.zerocarbon.com.pk',

  notificationSocketURL: 'wss://staging.zerocarbon.com.pk/notify/',
  commentsSocketURL: 'wss://staging.zerocarbon.com.pk/comments/'
};
